import { Component } from 'vue-property-decorator';
import Layer from './Layer.vue';
import { EModalName } from '@/helpers/modal';

@Component({})
export default class LayerMobile extends Layer {
  showNewComponentModal() {
    this.$modal.show(EModalName.newComponent);
  }
}
